module.exports = __webpack_public_path__ + "img/collection-weddingRingsModern@2x.e845a1a.webp";